import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';

import { withStyles } from '@material-ui/core';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import HomeBoldIcon from '@/assets/icons/HomeBoldIcon';
import Home from '@/assets/icons/Home';
import { Button } from '@/components/ui/button';
import BoligmappaPlusMenuIcon from '@/assets/icons/BoligmappaPlusMenuIcon';
import ProfileBoldIcon from '@/assets/icons/ProfileBoldIcon';
import BoligmappaPlusNavMenu from '@/components/BoligmappaPlusNavMenu';
import ProfileNavMenu from '@/components/ProfileNavMenu';

import styles, { logoSize } from './style';
import Box from '../atomic/Box';
import useHeaderSnackbar from '../../hooks/useHeaderSnackbar';
import ContentLoader from '../loaders/ContentLoader';
import { getPropertyAddress } from '../../utils/properties';
import { isIOSNativeEnvironment } from '../../utils/nativeBridge';
import MenuHorizontal from '../../assets/icons/MenuHorizontal';

const Header = ({
  classes,
  isDesktop,
  propertySelectLayout,
  setHeaderHeight,
  headerChild,
  headerSearch,
  isSearching,
  onMenuIconClick,
  fetching,
  activeProperty,
  ownedProperties,
  sharedProperties,
}) => {
  const history = useHistory();
  const mobHeaderRef = useRef(null);
  const { snackbarHeight } = useHeaderSnackbar();
  const isIOSNative = isIOSNativeEnvironment();

  useEffect(() => {
    if (setHeaderHeight) {
      setHeaderHeight(mobHeaderRef.current.offsetHeight + snackbarHeight);
    }
  }, [mobHeaderRef.current?.offsetHeight, snackbarHeight]);

  return (
    <div
      ref={mobHeaderRef}
      className={clsx([
        classes.header,
        propertySelectLayout && classes.propertyAlign,
        isDesktop && !propertySelectLayout && 'hide',
      ])}
      style={{ top: snackbarHeight }}
    >
      {isIOSNative && snackbarHeight === 0 && (
        <div className={classes.iosNativeNotch} />
      )}
      <div className="flex h-[46px] gap-[7px] font-circular">
        <Select
          onValueChange={(value) => history.push(`/dashboard/${value}/home`)}
          value={activeProperty?.boligmappaNumber}
        >
          <SelectTrigger className="w-[180px] w-full h-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {ownedProperties &&
              sharedProperties &&
              [...ownedProperties, ...sharedProperties].map(
                (property, index) => (
                  <>
                    <SelectItem
                      className="flex items-center"
                      value={property.boligmappaNumber}
                    >
                      <div className="grid grid-cols-[16px_1fr] gap-2 items-center">
                        {index === 0 ? <HomeBoldIcon /> : <Home />}
                        <p>{getPropertyAddress(property)}</p>
                      </div>
                    </SelectItem>
                    <SelectSeparator />
                  </>
                )
              )}
          </SelectContent>
        </Select>
        {!isDesktop &&
          !isSearching &&
          (fetching ? (
            <div className={classes.content}>
              <ContentLoader variant="circle" className={classes.logoLoader} />
              <Box width="100%" paddingRight={`${logoSize}px`}>
                <ContentLoader width={150} height={20} />
              </Box>
            </div>
          ) : (
            <>
              <BoligmappaPlusNavMenu activeProperty={activeProperty}>
                <Button variant="outline" className="p-3 h-full [&_svg]:size-6">
                  <BoligmappaPlusMenuIcon />
                </Button>
              </BoligmappaPlusNavMenu>
              <ProfileNavMenu activeProperty={activeProperty}>
                <Button variant="outline" className="p-3 h-full [&_svg]:size-6">
                  <ProfileBoldIcon fill="#000" />
                </Button>
              </ProfileNavMenu>
            </>
          ))}
        {onMenuIconClick && (
          <button
            className={classes.editItemButton}
            type="button"
            onClick={onMenuIconClick}
            aria-label="Menu Horizontal"
          >
            <MenuHorizontal />
          </button>
        )}
      </div>
      {headerSearch && (
        <div className="flex gap-[7px] font-circular">{headerSearch}</div>
      )}
      {headerChild && headerChild}
    </div>
  );
};

export default withStyles(styles)(Header);
